function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.281 5.248l-14.1 2.326C15.049 7.54.5 6.925.5 6.925c-.01.54.365.998.872 1.11l12.657 2.6c.092.341.284.659.575.902l.879.738v.63l-1.19 1.866.013.018c-.262.292-.38.697-.291 1.101a1.433 1.433 0 00-.728-.557 1.525 1.525 0 00-1.056 2.86l.063.022 1.398.481a.688.688 0 00.875-.427l.087-.252.795 2.6-.598 4.874c.397.05.69-.105.899-.658l1.027-3.359a.744.744 0 00.026-.122l.087-.712v-.006c.003-.026.002-.053.002-.08 0-.02.003-.039.002-.059-.003-.029-.129-1.533-.241-2.887l-.242-1.851.148-.041.473 1.038c.767-.507 1.335-1.323 1.419-2.25l.113-2.415-.273-1.639-1.061-.06-.035-.127 1.58-.516 9.775-3.291c.49-.174.806-.674.731-1.208z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "5",
  width: "30",
  height: "21"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.281 5.248l-14.1 2.326C15.049 7.54.5 6.925.5 6.925c-.01.54.365.998.872 1.11l12.657 2.6c.092.341.284.659.575.902l.879.738v.63l-1.19 1.866.013.018c-.262.292-.38.697-.291 1.101a1.433 1.433 0 00-.728-.557 1.525 1.525 0 00-1.056 2.86l.063.022 1.398.481a.688.688 0 00.875-.427l.087-.252.795 2.6-.598 4.874c.397.05.69-.105.899-.658l1.027-3.359a.744.744 0 00.026-.122l.087-.712v-.006c.003-.026.002-.053.002-.08 0-.02.003-.039.002-.059-.003-.029-.129-1.533-.241-2.887l-.242-1.851.148-.041.473 1.038c.767-.507 1.335-1.323 1.419-2.25l.113-2.415-.273-1.639-1.061-.06-.035-.127 1.58-.516 9.775-3.291c.49-.174.806-.674.731-1.208z",
  fill: "currentColor"
}))));